module.exports = __webpack_public_path__ + "img/m8luoding.prt.2dbae33f.jpg";